module.exports = __webpack_public_path__ + "img/realestate-realvest.75966dd2.jpg";